import React from 'react';
import Modal from '@omilia/modal';

// @ts-ignore
import messages from 'constants/messages';
import ModalButtons from 'components/ModalButtons';
import { SContainer } from '../styled';

type Props = {
  onCancel: () => void;
};

const UpdateFromParentSuccessModal = ({ onCancel }: Props) => (
  <Modal
    open
    data-test="version-control-modal"
    glyph="notification-verify"
    hasBackdrop={false}
    title={messages.VERSION_CONTROL.MERGE_MODAL.UPDATE_SUCCESS}
    variant="success"
  >
    <SContainer>
      {messages.VERSION_CONTROL.MERGE_MODAL.UPDATE_PARENT_SUCCESS}
      <ModalButtons
        primary={{
          text: 'Close',
          onClick: onCancel,
          type: 'button',
        }}
      />
    </SContainer>
  </Modal>
);

export default UpdateFromParentSuccessModal;
